import { useQuery } from "@tanstack/react-query";
import api from "../config/axiosConfig";

//Hook para cacheLoader
export const fetchActividades = async () => {
  try {
    const response = await api.get("/actividadEconomica");
    return response.data;
  } catch (error) {
    // console.error("❌ Error al obtener actividades económicas:", error);
    throw new Error(error?.mensaje || "No se pudo cargar la información de actividades económicas");
  }
};

// Hook reutilizable con React Query
export const useActividadesEconomicas = () => {
  return useQuery({
    queryKey: ["actividadesEconomicas"],
    queryFn: fetchActividades,
    staleTime: 1000 * 60 * 60 * 24 * 7, // 7 días (igual que en CacheLoader.js)
    cacheTime: 1000 * 60 * 60 * 24 * 14, // 14 días (igual que en CacheLoader.js)
  });
};
